import {FormActionButtons, FormContainer, FormattedFormRow, NumberField} from "@dvrt/graphql-widgets";
import {useEffect, useState} from "react";
import {useSystemSettingsQuery, useUpdateSystemSettingsMutation} from "./queries.generated";
import Loading from "../breadcrumbs/Loading";
import {useForm} from "@/utils/Form";
import {useDispatch} from "react-redux";
import {showNotification} from "@/actions";
import {defineMessage} from "react-intl";
import {FormattedPageTitle} from "../pages";
import {formPagesWidth} from "@/constants";

const UpdateSystemSettings = () => {
    const dispatch = useDispatch();

    const form = useForm(
        useUpdateSystemSettingsMutation,
        "updateSystemSettings",
        {
            preserveCcPresenceChangesFor: 0,
            preserveCallRecordsFor: 0,
        },
        (_) =>
            dispatch(
                showNotification(
                    defineMessage({id: "save_success", defaultMessage: "Data successfully saved"}),
                    "success",
                ),
            ),
        (_) =>
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            ),
    );
    const currentSystemSettingsQuery = useSystemSettingsQuery();

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (currentSystemSettingsQuery.data) {
            form.newInitialData({
                preserveCallRecordsFor: currentSystemSettingsQuery.data.systemSettings.preserveCallRecordsFor,
                preserveCcPresenceChangesFor:
                    currentSystemSettingsQuery.data.systemSettings.preserveCcPresenceChangesFor,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSystemSettingsQuery.data]);

    if (!currentSystemSettingsQuery.data && currentSystemSettingsQuery.loading) {
        return <Loading />;
    }

    const handleSubmit = async () => {
        setSubmitting(true);
        await form.submit();
        await currentSystemSettingsQuery.refetch();
        setSubmitting(false);
    };

    return (
        <div>
            <FormattedPageTitle desc={defineMessage({id: "system_settings", defaultMessage: "System settings"})} />
            <FormContainer sx={{width: formPagesWidth}}>
                <FormattedFormRow
                    label={defineMessage({
                        id: "system_settings_page.preserve_call_records_for",
                        defaultMessage: "Preserve call records for (months)",
                    })}
                >
                    <NumberField
                        min={0}
                        value={form.values.preserveCallRecordsFor}
                        update={(val) => form.updateValues({preserveCallRecordsFor: val})}
                        disabled={submitting}
                    />
                </FormattedFormRow>
                <FormattedFormRow
                    label={defineMessage({
                        id: "system_settings_page.preserve_cc_presence_changes_for",
                        defaultMessage: "Preserve call center presence changes for (months)",
                    })}
                >
                    <NumberField
                        min={0}
                        value={form.values.preserveCcPresenceChangesFor}
                        update={(val) => form.updateValues({preserveCcPresenceChangesFor: val})}
                        disabled={submitting}
                    />
                </FormattedFormRow>
                <FormattedFormRow>
                    <FormActionButtons
                        mainAction={handleSubmit}
                        secondaryAction={() => form.reset()}
                        enabled={form.hasChanged && !submitting}
                    />
                </FormattedFormRow>
            </FormContainer>
        </div>
    );
};

export default UpdateSystemSettings;
